import { route } from "quasar/wrappers";
import { createRouter, createWebHistory } from "vue-router";
import routes from "src/router/routes";

export default route(async () => {
  const router = createRouter({
    routes: routes,
    history: createWebHistory(),
    scrollBehavior: () => {
      return { top: 0 };
    },
  });

  return router;
});
